/* ============================================================
   custom.js
   Geladen mit defer vor </body> in layout/theme.liquid.
   Alle Custom-Scripts des Themes.
   ============================================================ */


/* ============================================
   PRODUCT TYPE TOOLTIP
   Öffnen/Schließen Logik für .mt-product-type-tooltip.
   Schließt andere offene Tooltips, schließt bei Outside-Click,
   schließt bei Escape.
   ============================================ */

(() => {
  function closeAll(exceptEl) {
    document.querySelectorAll('.mt-product-type-tooltip-wrapper.is-open').forEach((el) => {
      if (exceptEl && el === exceptEl) return;
      el.classList.remove('is-open');
      const btn = el.querySelector('.mt-product-type-tooltip-icon');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.mt-product-type-tooltip-icon');
    const wrapper = e.target.closest('.mt-product-type-tooltip-wrapper');

    if (btn && wrapper) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = wrapper.classList.contains('is-open');
      closeAll(wrapper);

      if (!isOpen) {
        wrapper.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        wrapper.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
      return;
    }

    if (e.target.closest('.mt-tooltip-box')) return;
    closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();


/* ============================================
   PDP VARIANT SCROLL RESTORE
   Hält die Scroll-Position stabil, wenn ein User auf der
   Produktseite eine Variante wechselt. Merkt sich Y bei
   pointerdown/touchstart innerhalb der Variant-UI, setzt
   Position nach variant:changed / pushState / popstate /
   hashchange zurück, solange lockUntil nicht abgelaufen ist.
   Guard window.__sfScrollFixHistoryHooked verhindert
   Doppel-Hook der history-Methoden bei mehrfacher Ausführung.
   ============================================ */

(() => {
  let lastY = null;
  let lockUntil = 0;

  const remember = (e) => {
    if (!document.querySelector('product-info, .product__info, form[action="/cart/add"]')) return;

    const inVariantUI =
      e.target.closest('[data-variant-picker]') ||
      e.target.closest('variant-picker') ||
      e.target.closest('.variant-picker') ||
      e.target.closest('.product-variant') ||
      e.target.closest('[name^="options"]') ||
      e.target.closest('[name="id"]') ||
      e.target.closest('[data-option-value]');

    if (!inVariantUI) return;

    lastY = window.scrollY;
    lockUntil = Date.now() + 1200;
  };

  document.addEventListener('pointerdown', remember, true);
  document.addEventListener('touchstart', remember, true);

  const restore = () => {
    if (lastY == null) return;
    if (Date.now() > lockUntil) return;

    const y = lastY;
    requestAnimationFrame(() => {
      window.scrollTo(0, y);
      requestAnimationFrame(() => window.scrollTo(0, y));
    });
  };

  document.addEventListener('variant:changed', restore, true);
  document.addEventListener('product:variant-change', restore, true);
  document.addEventListener('theme:variant:change', restore, true);

  if (!window.__sfScrollFixHistoryHooked) {
    window.__sfScrollFixHistoryHooked = true;

    const wrap = (fn) =>
      function () {
        const ret = fn.apply(this, arguments);
        restore();
        return ret;
      };

    history.pushState = wrap(history.pushState);
    history.replaceState = wrap(history.replaceState);
    window.addEventListener('popstate', restore);
  }

  window.addEventListener(
    'hashchange',
    () => {
      if (Date.now() <= lockUntil) restore();
    },
    true
  );
})();


/* ============================================
   GALLERY „MEHR ANZEIGEN“ (Desktop-Grid)
   Blendet im Desktop-Grid der Produktgalerie zunaechst nur N Bilder
   ein und zeigt darunter einen „Mehr anzeigen“-Button. Aufklappen
   zeigt alle Bilder und scrollt zur ersten neu eingeblendeten Kachel;
   Einklappen scrollt zur Ausgangsposition zurueck.

   - Nur Desktop (>= 768px, gleicher Breakpoint wie das Grid-Layout).
     Auf Mobile ist die Desktop-Galerie ohnehin display:none, zusaetzlich
     schaltet die Logik den Button hier aus und zeigt alle Kacheln.
   - Als Custom-Element: initialisiert sich per connectedCallback
     automatisch neu, auch wenn das Theme den Produktblock bei einem
     Variantenwechsel via innerHTML ersetzt (Inline-<script> wuerde dabei
     nicht erneut ausgefuehrt).
   - Anzahl der sichtbaren Bilder kommt aus data-visible-count (Section-
     Setting). Ob der Button ueberhaupt gerendert wird (Schwellenwert),
     entscheidet bereits Liquid in product-media-list.liquid.
   ============================================ */
(() => {
  const DESKTOP_MQ = '(min-width: 768px)';

  class GalleryShowMore extends HTMLElement {
    connectedCallback() {
      this.container = this.closest('[data-product-media-container]');
      this.grid = this.container ? this.container.querySelector('.product-media-grid') : null;
      this.btn = this.querySelector('.gallery-show-more__btn');
      this.textEl = this.querySelector('.gallery-show-more__text');

      if (!this.grid || !this.btn) {
        this.style.display = 'none';
        return;
      }

      const parsed = parseInt(this.getAttribute('data-visible-count'), 10);
      this.visibleCount = parsed > 0 ? parsed : 4;
      this.textMore = this.getAttribute('data-text-more') || 'Mehr anzeigen';
      this.textLess = this.getAttribute('data-text-less') || 'Weniger anzeigen';
      this.expanded = false;

      this._onClick = this._onClick.bind(this);
      this._onResize = this._onResize.bind(this);
      this.btn.addEventListener('click', this._onClick);
      window.addEventListener('resize', this._onResize);

      this._apply();
    }

    disconnectedCallback() {
      if (this.btn) this.btn.removeEventListener('click', this._onClick);
      window.removeEventListener('resize', this._onResize);
      clearTimeout(this._resizeTimer);
    }

    _items() {
      return Array.from(this.grid.querySelectorAll('.product-media-grid__item'));
    }

    _isDesktop() {
      return window.matchMedia(DESKTOP_MQ).matches;
    }

    // Bild-Kacheln wieder in ihren Ausgangszustand bringen (Inline-display entfernen)
    _showAll() {
      this._items().forEach((el) => el.style.removeProperty('display'));
    }

    _apply() {
      const items = this._items();
      // Auf Mobile oder wenn nicht mehr Bilder als standardmaessig sichtbar:
      // nichts kappen, Button ausblenden.
      if (!this._isDesktop() || items.length <= this.visibleCount) {
        this._showAll();
        this.style.display = 'none';
        return;
      }
      this.style.removeProperty('display');
      if (this.expanded) {
        this._expand();
      } else {
        this._collapse();
      }
    }

    _collapse() {
      this._items().forEach((el, i) => {
        if (i >= this.visibleCount) {
          el.style.display = 'none';
        } else {
          el.style.removeProperty('display');
        }
      });
      this.expanded = false;
      if (this.textEl) this.textEl.textContent = this.textMore;
      this.btn.classList.remove('is-expanded');
      this.btn.setAttribute('aria-expanded', 'false');
    }

    _expand() {
      this._showAll();
      this.expanded = true;
      if (this.textEl) this.textEl.textContent = this.textLess;
      this.btn.classList.add('is-expanded');
      this.btn.setAttribute('aria-expanded', 'true');
    }

    _onClick() {
      if (!this._isDesktop()) return;
      const items = this._items();
      if (!this.expanded) {
        // Aufklappen: alle Bilder zeigen und zur ersten neu eingeblendeten
        // Kachel scrollen (block:start + scroll-margin-top landet knapp unter
        // dem Header).
        this._expand();
        const target = items[this.visibleCount];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // Einklappen: zurueck an den Anfang der Galerie / der PDP scrollen
        // (erste Bild-Kachel oben), nicht zur vorherigen Scroll-Position.
        this._collapse();
        if (items[0]) {
          items[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    }

    _onResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this._apply(), 150);
    }
  }

  if ('customElements' in window && !customElements.get('gallery-show-more')) {
    customElements.define('gallery-show-more', GalleryShowMore);
  }
})();
